<template>
  <div :class="['offer-bar', theme.color]">
    <AmTypography
      class="offer-bar__message"
      :text="offerMessage"
      typography-style="l1"
      textColor="white"
    />
    <AmAnalogTimer
      v-model="timer"
      class="offer-bar__timer"
      flat
    />
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'OfferBar',
  mixins: [themeMixin],
  data() {
    return {
      timeRemaining: 0,
      offerMessage: 'Oferta por tempo limitado!',
    }
  },
  computed: {
    ...mapState('Checkout', {
      settings: (state) => state.cart.settings,
    }),
    timer() {
      return moment().add(this.timeRemaining, 'seconds')
    },
  },
  watch: {
    settings: {
      immediate: true,
      handler(newValue) {
        const { timer } = newValue
        if (timer.time) {
          this.timeRemaining = timer.time
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.offer-bar {
  width: 100%;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mobile {
    justify-content: space-between;
  }

  @include desktop {
    &__message {
      margin: {
        right: 24px;
      }
    }
  }

  @include tablet {
    &__message {
      margin: {
        right: 24px;
      }
    }
  }

  @include mobile {
    &__message {
      margin: {
        left: 24px;
      }
      & ::v-deep div.prose {
        font-size: 16px;
      }
    }

    &__timer {
      margin: {
        right: 24px;
      }
      & ::v-deep .am-typography div {
        font-size: 16px;
      }
    }
  }

  &__timer {
    ::v-deep {
      align-content: flex-end;
      .am-analog-timer__clock {
        color: $white;
        align-content: flex-end;
        .am-analog-timer__clock__hours__flat,
        .am-analog-timer__clock__minutes__flat,
        .am-analog-timer__clock__seconds__flat {
          padding: 0;
          margin: 0;
          div {
            color: $white;
            font-weight: 700;
          }
        }
        .am-analog-timer__clock__divider {
          padding: 0;
          margin: 0;
          div {
            color: $white;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
